/*
 * Reposiciona el widget flotante de Google Merchant en DESKTOP para que no tape
 * el contenido. En móvil se deja la posición original de Google.
 *
 * El widget aplica sus estilos inline desde JS, por lo que el CSS externo (incluso
 * con !important) no puede vencerle. Usamos MutationObserver para reaplicar la
 * posición deseada cada vez que Google modifique el atributo `style` del wrapper.
 */
(function () {
  'use strict';

  var WRAPPER_ID = 'google-merchantwidget-iframe-wrapper';
  var DESIRED_BOTTOM = '80px';
  var DESIRED_LEFT = '20px';
  var DESKTOP_MIN_WIDTH = 768;

  var applying = false;
  var originalBottom = null;
  var originalLeft = null;

  function isDesktop() {
    return window.innerWidth >= DESKTOP_MIN_WIDTH;
  }

  function applyPosition(el) {
    if (!el || applying) return;

    if (isDesktop()) {
      if (originalBottom === null) {
        originalBottom = el.style.bottom || '';
        originalLeft = el.style.left || '';
      }
      if (
        el.style.bottom === DESIRED_BOTTOM &&
        el.style.left === DESIRED_LEFT &&
        el.style.getPropertyPriority('bottom') === 'important' &&
        el.style.getPropertyPriority('left') === 'important'
      ) {
        return;
      }
      applying = true;
      el.style.setProperty('bottom', DESIRED_BOTTOM, 'important');
      el.style.setProperty('left', DESIRED_LEFT, 'important');
      applying = false;
    } else {
      if (
        el.style.getPropertyPriority('bottom') === 'important' ||
        el.style.getPropertyPriority('left') === 'important'
      ) {
        applying = true;
        el.style.removeProperty('bottom');
        el.style.removeProperty('left');
        if (originalBottom) el.style.bottom = originalBottom;
        if (originalLeft) el.style.left = originalLeft;
        applying = false;
      }
    }
  }

  var styleObserver = null;
  var watchedEl = null;

  function watchWrapper(el) {
    watchedEl = el;
    applyPosition(el);
    if (styleObserver) return;
    styleObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'style') {
          applyPosition(el);
          break;
        }
      }
    });
    styleObserver.observe(el, { attributes: true, attributeFilter: ['style'] });
  }

  function init() {
    var existing = document.getElementById(WRAPPER_ID);
    if (existing) {
      watchWrapper(existing);
      return;
    }
    var bodyObserver = new MutationObserver(function () {
      var el = document.getElementById(WRAPPER_ID);
      if (el) {
        bodyObserver.disconnect();
        watchWrapper(el);
      }
    });
    bodyObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (!watchedEl) return;
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      applyPosition(watchedEl);
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
